export default __webpack_public_path__ + "static/media/maintenance.bad2979c.png";